import { CircleAlert, MessageSquareText } from 'lucide-react';

import type { TNotification } from '@src/shared/types/notification';

export const renderNotificationIcon = (type: TNotification['meta_type']) => {
  switch (type) {
    case 'INFO':
      return <MessageSquareText className='text-primary-500' />;
    case 'ALERT':
      return <CircleAlert className='text-primary-500' />;
    default:
      return <CircleAlert className='text-primary-500' />;
  }
};
